import { CdkVirtualScrollable } from '@angular/cdk/scrolling';
import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[blazeVirtualScrollableElement]',
  host: {
    class: 'blaze-virtual-scrollable',
  },
  standalone: false,
})
export class BlazeVirtualScrollableElementDirective extends CdkVirtualScrollable {
  @Input() @HostBinding('class.with-theme') useAppTheme = false;

  measureBoundingClientRectWithScrollOffset(from: 'left' | 'top' | 'right' | 'bottom'): number {
    return (
      this.getElementRef().nativeElement.getBoundingClientRect()[from] -
      this.measureScrollOffset(from)
    );
  }
}
